import { render, staticRenderFns } from "./Main2.vue?vue&type=template&id=0f5e7e6e&scoped=true"
import script from "./Main2.vue?vue&type=script&lang=js"
export * from "./Main2.vue?vue&type=script&lang=js"
import style0 from "./Main2.vue?vue&type=style&index=0&id=0f5e7e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5e7e6e",
  null
  
)

export default component.exports